module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"yes":"yes","no":"no"},"de":{"yes":"ja","no":"nein"}}')
  delete Component.options._Ctor
}
